import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
export const BaseHeaderSchema = ApiLambdalerAuthHeaderSchema.pick({ requestActor: true }).required({
    requestActor: true,
});
